



























import Vue from 'vue';

export default Vue.extend({
  props: {
    buttons: {
      type: Object,
      default() {
        return {
          yes: {show: true, text: '确定'},
          preview: {show: false, text: '预览'},
          no: {show: true, text: '取消'},
        };
      },
    },
    withFooter: {
      type: Boolean,
      default: false,
    },
    show: Boolean,
    showBack: {
      type: Boolean,
      default: false,
    },
    backOpration: {
      type: Function,
    },
    title: String,
    modal: Boolean,
    width: {
      type: Number,
      default: 800,
    },
  },
  methods: {
    getSidePageHeight() {
      this.sidePageHeight = window.innerHeight - 40;
    },
    onScroll(e: any): void {
      const target = e.target;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      if (scrollTop === 0) {
        this.scroll = -1;
      } else if (scrollTop > 0) {
        if (scrollTop + this.sidePageHeight - scrollHeight >= 0) {
          this.scroll = 1;
        } else {
          this.scroll = 0;
        }
      }
    },
    hideSidePage() {
      this.$emit('onClose');
    },
    getScrollWidth() {
      const oDiv = document.createElement('DIV');
      oDiv.style.cssText = 'position:absolute; top:-1000px; width:100px; height:100px; overflow:hidden;';
      const noScroll = document.body.appendChild(oDiv).clientWidth;
      oDiv.style.overflowY = 'scroll';
      const scroll = oDiv.clientWidth;
      document.body.removeChild(oDiv);
      this.scrollWidth = noScroll - scroll;
    },
    updatePageOverflow(isShow: boolean) {
      const html = document.getElementsByTagName('html')[0];
      if (isShow) {
        html.style.overflow = 'hidden';
        html.style.position = 'relative';
        html.style.left = (-this.scrollWidth / 2) + 'px';
      } else {
        html.style.overflow = 'auto';
        html.style.left = 'auto';
      }
    },
    stopPropagation(e: any) {
      e.stopPropagation();
    },
  },
  watch: {
    show(newVal, oldVal) {
      this.updatePageOverflow(newVal);
      this.$nextTick(function() {
        const container = this.$el.getElementsByClassName('page-body')[0];
        if (window.innerHeight > container.scrollHeight) {
          // this.scroll = 1
        }
      });
    },
  },
  data() {
    return {
      sidePageHeight: window.innerHeight - 40,
      scroll: -1,
      scrollWidth: 0,
    };
  },
  mounted() {
    window.addEventListener('resize', this.getSidePageHeight);
    window.addEventListener('click', (event: any) => {
      if (!this.$props.modal && this.$props.show) {
        this.$emit('close');
      }
    });
    this.getScrollWidth();
    this.updatePageOverflow(this.$props.show);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getSidePageHeight);
    this.updatePageOverflow(false);
  },
});
